module.exports = {"id":"221430","name":"Uroš Đurđević","rating":"73","photo":"./data/images/photos/4/221430.png","club":{"name":"Olympiakos CFP","logo":"./data/images/clubs/OlympiakosCFP.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/UrosĐurđevic0.json
// module id = 4213
// module chunks = 0